import { useEffect } from "react";
import { useDispatch } from "react-redux";
import useSocket, { getSharedSocket } from "./useSocket";
import { setHasActiveEventsFromSocket } from "../features/event/eventSlice";

const HAS_ACTIVE_EVENTS_EVENT = "has-active-events";

const normalizeHasActiveEvents = (data) => {
  if (typeof data === "boolean") return data;
  if (data && typeof data === "object") return Boolean(data.hasActiveEvents);
  return false;
};

/**
 * Listens for backend `has-active-events` pushes and always overrides API state.
 * Also requests the current value on connect/reconnect.
 * Response shape: { hasActiveEvents: boolean } | boolean
 */
export default function useHasActiveEventsListener() {
  const dispatch = useDispatch();
  const { socketRef, isReady } = useSocket();

  useEffect(() => {
    const socket = socketRef.current || getSharedSocket();
    if (!socket) return;

    const handleHasActiveEvents = (data) => {
      dispatch(setHasActiveEventsFromSocket(normalizeHasActiveEvents(data)));
    };

    const requestHasActiveEvents = () => {
      socket.emit(HAS_ACTIVE_EVENTS_EVENT);
    };

    socket.off(HAS_ACTIVE_EVENTS_EVENT, handleHasActiveEvents);
    socket.on(HAS_ACTIVE_EVENTS_EVENT, handleHasActiveEvents);

    socket.off("connect", requestHasActiveEvents);
    socket.on("connect", requestHasActiveEvents);

    if (socket.connected) {
      requestHasActiveEvents();
    }

    return () => {
      socket.off(HAS_ACTIVE_EVENTS_EVENT, handleHasActiveEvents);
      socket.off("connect", requestHasActiveEvents);
    };
  }, [dispatch, isReady, socketRef]);
}
